import { useEffect, useState } from 'react';
import {
  ButtonPseudo,
  SidePanel,
  SidePanelType,
  SidePanelLoader,
  ButtonSecondary,
  ButtonSize,
} from '@ui/src';
import { AmlChangeLogsTypes } from './types';
import { CustomerScore } from '../types';
import AmlChangeLog from './change-log';

import cn from './styles.module.css';

const orderIsOdd = (order: number) => {
  const isOdd = order % 2;

  return Boolean(isOdd);
};

const AmlChangeLogs = ({
  panelIsOpen,
  handleCloseAmlChangeLogsPanel,
  getAmlChangeLogs,
  amlChangeLogsIsLoading,
  amlChangeLogs,
  amlChangeLogsPagination,
  amlScoresHistoryIsFetching,
  users,
  type,
  organizationId,
  applicationId,
}: AmlChangeLogsTypes) => {
  const [evenLogs, setEvenLogs] = useState<CustomerScore[]>([]);
  const [oddLogs, setOddLogs] = useState<CustomerScore[]>([]);

  useEffect(() => {
    if (panelIsOpen) {
      getAmlChangeLogs();
    }
  }, [panelIsOpen]);

  useEffect(() => {
    if (amlChangeLogs && amlChangeLogs?.length) {
      const evenLogsList: CustomerScore[] = [];
      const oddLogsList: CustomerScore[] = [];

      amlChangeLogs?.forEach((item) => {
        if (orderIsOdd(item.order as number)) {
          oddLogsList.push(item);
        } else {
          evenLogsList.push(item);
        }
      });

      setEvenLogs(evenLogsList);
      setOddLogs(oddLogsList);
    }
  }, [amlChangeLogs]);

  return (
    <SidePanel
      title="Customer Risk Score: Change log"
      isOpen={panelIsOpen}
      type={SidePanelType.Transactions}
      sidepanelExpandedKey="aml-risk-score-change-logs"
      onClose={() => {
        handleCloseAmlChangeLogsPanel();
        setEvenLogs([]);
        setOddLogs([]);
      }}
      footer={
        <ButtonPseudo
          text="Close"
          onClick={() => {
            handleCloseAmlChangeLogsPanel();
            setEvenLogs([]);
            setOddLogs([]);
          }}
          bold
        />
      }
      closeOnClickOutside
    >
      {amlChangeLogsIsLoading ||
      (amlScoresHistoryIsFetching && !amlChangeLogs) ? (
        <SidePanelLoader />
      ) : (
        <div>
          {oddLogs?.map((item) => (
            <AmlChangeLog
              key={item.id}
              type={type}
              amlChangeLog={item}
              evenChangeLog={
                evenLogs?.find(
                  (evenLog) => evenLog?.order === (item.order as number) + 1,
                ) || undefined
              }
              userName={
                item?.employeeId
                  ? users?.find((user) => user.value === item.employeeId)?.name
                  : ''
              }
              organizationId={organizationId}
              applicationId={applicationId}
            />
          ))}
          {amlChangeLogsPagination && amlChangeLogsPagination?.hasNextPage && (
            <div className={cn.showMoreButtonWrapper}>
              <ButtonSecondary
                size={ButtonSize.SMALL}
                text={amlScoresHistoryIsFetching ? 'Loading...' : 'Show more'}
                onClick={() =>
                  getAmlChangeLogs(amlChangeLogsPagination.endCursor)
                }
              />
            </div>
          )}
        </div>
      )}
    </SidePanel>
  );
};

export default AmlChangeLogs;
